import React from 'react';

import CaliItem from './caliItem';

import './caliList.css'

const CaliList = (props) => {
    // const today = new Date().toLocaleDateString('en-CA');
    // console.log('ahahahah', today)
    return (
        <main>
            
            <table id='cales'> 
                    <tr className='ur'>
                        <th></th>
                        <th>Билгийн <br/>Тоолол</th>
                        <th>Аргын <br/> Тоолол</th> 
                        <th>Жил өдөр</th> 
                        <th>Дүвзий саран</th> 
                        <th>Жэдзий саран</th>   
                        <th>Суудал</th> 
                        <th>Мэнгэ</th> 
                        <th>Барилдлага</th> 
                        <th>Шүтэн Барилдлага</th> 
                        <th>Наран <br/> ургах/шингэх</th> 
                        <th>Саран <br/> ургах/шингэх</th> 
                        <th>Эзэн өдөр</th>   
                        <th>Мөр гаргах</th>
                        <th>Өдрийн үр</th>    
                    </tr>   
          
                {/* <tbody> */}
                    {props.cale.map((c, i) => (              
                        <CaliItem
                            key={i}
                            year_id={c.year_id}
                            month_id={c.month_id}
                            garag_id={c.garag_id}
                            name_arga={c.garag_name_arga}
                            name_bilig={c.garag_name_bilig}
                            day_number={c.day_number}
                            western_date={c.western_date}
                            bilig_day={c.bilig_day}
                            garag={c.garag}
                            jil_odor={c.jil_odor}
                            menge={c.menge}
                            suudal={c.suudal}
                            duvzi_od={c.duvzi_od}
                            jedzi_od={c.jedzi_od}
                            barildlaga={c.barildlaga}
                            mor_gargah={c.mor_gargah}
                            sh_barildlaga={c.sh_barildlaga}
                            ezen_odor={c.ezen_odor}
                            sunrise={c.sunrise}
                            sunset={c.sunset}
                            moonrise={c.moonrise}
                            moonset={c.moonset}
                            udriin_ur={c.udriin_ur}     
                                                 
                        />                    
                    ))}   
                {/* </tbody> */}
                 
            </table>      
        </main>
    )
} 
export default CaliList;